<template>
    <Contenuti :soloManuale="true" :titolo="'Manuali'"></Contenuti>
</template>
<script>
import Contenuti from '@/components/Contenuti.vue'


export default {
    name:"Manuals",
    components:{
        Contenuti,
    },
}
</script>